import {createContext} from 'react';

type AuthenticationConfig = {
    domain?: string,
    clientId?: string,
    issuerUri?: string,
    callback?: string,
    source?: string,
};

type AuthenticationContextType = {
    config: AuthenticationConfig,
    isLogoutRequested: boolean,
    requestLogout: (isLogoutRequested: boolean) => void,
};

export const DEFAULT_AUTHENTICATION_CONFIG: AuthenticationConfig = {};

const DEFAULT_CONTEXT: AuthenticationContextType = {
    config: DEFAULT_AUTHENTICATION_CONFIG,
    isLogoutRequested: false,
    requestLogout: () => undefined,
};

export const AuthenticationContext = createContext<AuthenticationContextType>(DEFAULT_CONTEXT);
